import { Box, styled } from '@mui/material';

export const ChatRightPanelHeaderContainer = styled(Box, {
  shouldForwardProp: (prop: string) => !['isGlobalHeader'].includes(prop),
})<{ isGlobalHeader: boolean }>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: theme.palette.case.neutral.n0,
  height: '48px',
  flexGrow: 0,
  padding: '16px 20px',
  borderBottom: `1px solid ${theme.palette.case.neutral.n200}`,
  [theme.breakpoints.down('lg')]: {
    borderBottom: 'none',
  },
}));
